import styled from 'styled-components';

//todo get response from tranzila on transparent background and height
export const StyledBitPage = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  .iframe-wrapper{
    display: block;
    margin-left: auto;
    margin-right: auto;
    iframe {
      max-width: 420px;
      width: 100vw;
      min-width: 400px;
      min-height: 1000px;
      border: none;
      margin-bottom: 50px;
    }
  }
`
